function Loading(){

    return(
        <>
        <div className="jawaab_sako Load active">
        <div className="spinner">
            <div className="double-bounce1"></div>
            <div className="double-bounce2"></div>
        </div>
        </div>
        </>
    )
}


export default Loading